import Decimal from 'decimal.js';
import { isNil, isString, isNumber } from 'lodash-es';
import { DefaultPlatformTaxRate, DefaultPlatformUserRate, FreeCredit } from 'common/constants';

//061版本-调整费率计算，待废弃的费率计算逻辑
export const calculateTaskBefore061Cost = (
  value,
  userInfo = { userRate: DefaultPlatformUserRate, taxRate: DefaultPlatformTaxRate },
): {
  serveCost: string;
  actualPrice: string;
} => {
  if (isNil(value)) {
    return {
      serveCost: '-',
      actualPrice: '-',
    };
  }
  let { userRate, taxRate } = userInfo;
  const rate = Decimal.add(userRate || DefaultPlatformUserRate, taxRate || DefaultPlatformTaxRate);

  if (isString(value) && value?.includes('[')) {
    const [start, end] = JSON.parse(value);
    console.log({ value, start, end });
    const serveCost = `${Decimal.mul(start, rate).toFixed(2, Decimal.ROUND_CEIL)}-${Decimal.mul(end, rate).toFixed(2, Decimal.ROUND_CEIL)}`;
    const actualPrice = `${Decimal.mul(start, Decimal.add(rate, 1)).toFixed(2, Decimal.ROUND_CEIL)}-${Decimal.mul(end, Decimal.add(rate, 1)).toFixed(2, Decimal.ROUND_CEIL)}`;
    return {
      serveCost,
      actualPrice,
    };
  }

  const serveCost = Decimal.mul(value, rate);
  const actualPrice = Decimal.add(value, serveCost).toFixed(2, Decimal.ROUND_CEIL);
  return {
    serveCost: serveCost.toFixed(2, Decimal.ROUND_CEIL),
    actualPrice: actualPrice,
  };
};

// 根据需求方支付计算任务价格信息
export const calcTaskPriceInfoByPayment = ({
  payment,
  taxRate = DefaultPlatformTaxRate,
  userRate = DefaultPlatformUserRate,
}: {
  payment?: string;
  taxRate?: string;
  userRate?: string;
}) => {
  try {
    if (isNil(payment)) return { taskPrice: undefined, serviceCharge: undefined, income: undefined };
    const taskPrice = new Decimal(payment).div(1 + new Decimal(userRate).toNumber()).toFixed(2, Decimal.ROUND_FLOOR);
    const serviceCharge = new Decimal(payment).minus(taskPrice).toString();
    const income = new Decimal(payment)
      .div(1 + new Decimal(userRate).toNumber())
      .div(1 + new Decimal(taxRate).toNumber())
      .toFixed(2, Decimal.ROUND_FLOOR);
    return { taskPrice, serviceCharge, income };
  } catch (error) {
    return { taskPrice: undefined, serviceCharge: undefined, income: undefined };
  }
};

// 根据制作方收入计算任务价格信息
export const calcTaskPriceInfoByIncome = ({
  income,
  taxRate = DefaultPlatformTaxRate,
  userRate = DefaultPlatformUserRate,
}: {
  income?: string;
  taxRate?: string;
  userRate?: string;
}) => {
  try {
    if (isNil(income)) return { taskPrice: undefined, serviceCharge: undefined, payment: undefined };
    const taskPrice = new Decimal(income).mul(1 + new Decimal(taxRate).toNumber()).toFixed(2, Decimal.ROUND_CEIL);
    const payment = new Decimal(income)
      .mul(1 + new Decimal(taxRate).toNumber())
      .mul(1 + new Decimal(userRate).toNumber())
      .toFixed(2, Decimal.ROUND_CEIL);
    const serviceCharge = new Decimal(payment).minus(taskPrice).toString();

    return { taskPrice, serviceCharge, payment };
  } catch (error) {
    return { taskPrice: undefined, serviceCharge: undefined, payment: undefined };
  }
};

// 根据任务价格计算任务价格信息
export const calcTaskPriceInfoByTaskPrice = ({
  taskPrice,
  taxRate = DefaultPlatformTaxRate,
  userRate = DefaultPlatformUserRate,
}: {
  taskPrice?: string;
  taxRate?: string;
  userRate?: string;
}) => {
  try {
    if (isNil(taskPrice)) return { payment: undefined, serviceCharge: undefined, income: undefined };
    const serviceCharge = Decimal.mul(taskPrice, userRate).toFixed(2, Decimal.ROUND_CEIL);
    const payment = Decimal.add(taskPrice, serviceCharge).toString();
    const income = new Decimal(taskPrice).div(1 + new Decimal(taxRate).toNumber()).toFixed(2, Decimal.ROUND_FLOOR);
    const taxCharge = Decimal.sub(taskPrice, income).toString();

    return { payment, serviceCharge, income, taxCharge };
  } catch (error) {
    return { payment: undefined, serviceCharge: undefined, income: undefined };
  }
};

export const calculateCost = (value, allocator) => {
  const defaultResult = {
    serveCost: '-',
    actualPrice: '-',
  };

  try {
    if (isNil(value)) return defaultResult;
    const serveCost = Decimal.mul(value, allocator?.userRate || DefaultPlatformUserRate);
    const actualPrice = Decimal.add(value, serveCost).toFixed(2, Decimal.ROUND_CEIL);

    return {
      actualPrice,
      serveCost: serveCost.toFixed(2, Decimal.ROUND_CEIL),
    };
  } catch (e) {
    return defaultResult;
  }
};

export const formatterCost = (value) => {
  if (value && value.toString().indexOf('.') !== -1) {
    return value.toString().slice(0, value.toString().indexOf('.') + 3); // 限制最多两位小数
  }
  return value;
};

export function formatPrice(value: string | number) {
  const price = parseFloat(value.toString());
  //格式化为k或w的金额显示
  if (price >= 10000) {
    return `${(price / 10000).toFixed(2).replace(/\.00$/, '')}w`;
  } else if (price >= 1000) {
    return `${(price / 1000).toFixed(2).replace(/\.00$/, '')}k`;
  } else {
    return value.toString() || '-';
  }
}

export const parserFormattedCredit = (value) => {
  if (isNil(value)) {
    return '****';
  } else if (value?.toString() === FreeCredit) {
    return '自由议价';
  } else if (value?.includes('[')) {
    const priceRange = JSON.parse(value);
    return `${formatPrice(priceRange[0])}-${formatPrice(priceRange[1])}`;
  } else {
    return formatPrice(value);
  }
};

export const parserCreditToString = (value) => {
  if (isNil(value)) {
    return '****';
  } else if (value?.toString() === FreeCredit) {
    return '自由议价';
  } else if (isNumber(value)) {
    return value;
  } else if (value?.includes('[')) {
    const priceRange = JSON.parse(value);
    return priceRange.join('-');
  } else {
    return value || '-';
  }
};

//委托模式： 根据任务价格和服务费率，计算需求方支付价格和服务费
export const calculateTaskPriceByEntrustMode = ({ taskPrice, serviceRate }) => {
  if (isNil(taskPrice)) return { payment: undefined, serviceCharge: undefined };
  const serviceCharge = Decimal.mul(taskPrice, serviceRate).toFixed(2, Decimal.ROUND_CEIL);
  const payment = Decimal.add(taskPrice, serviceCharge).toString();
  return { payment, serviceCharge };
};
// 委托模式：根据支付价格和服务费率，计算任务价格和服务费
export const calculateTaskPriceByEntrustModeWithPayment = ({ payment, serviceRate }) => {
  if (isNil(payment)) return { taskPrice: undefined, serviceCharge: undefined };
  const taskPrice = new Decimal(payment)
    .div(1 + new Decimal(serviceRate).toNumber())
    .toFixed(2, Decimal.ROUND_FLOOR)
    .replace(/\.00$/, '');
  const serviceCharge = new Decimal(payment).minus(taskPrice).toString().replace(/\.00$/, '');
  return { taskPrice, serviceCharge };
};

// 平台模式: 根据任务价格计算到手金额和服务费
export const calculateTaskPriceByPlatformMode = ({ taskPrice, serviceRate }) => {
  if (isNil(taskPrice)) return { payment: undefined, serviceCharge: undefined, income: undefined };
  const serviceCharge = Decimal.mul(taskPrice, serviceRate).toFixed(2, Decimal.ROUND_CEIL).replace(/\.00$/, '');
  const income = Decimal.sub(taskPrice, serviceCharge).toFixed(2, Decimal.ROUND_FLOOR).replace(/\.00$/, '');
  return { serviceCharge, income };
};
